export const translation = {
  nav: {
    home: 'Hjem',
    categories: 'Kategorier',
    spreadsheet: 'Regneark',
    review: 'Anmeldelse',
    shipping: 'Forsendelse',
    coupon: 'Kupon',
    warehouse: 'Lager',
    legit: 'Er det Legitimt?',
    guide: 'Guider',
    blog: 'Blog',
    about: 'Om os',
    contact: 'Kontakt',
    language: 'Sprog',
  },
  hero: {
    eyebrow: 'ALLCHINABUY REGNEARK RESSOURCE-HUB',
    h1: 'AllChinaBuy Regneark — Find Produkter, Sælgere & Købsguider',
    description: 'Opdag nyttige AllChinaBuy regneark-ressourcer, produktfund, sælgerinformation, QC-guider, forsendelsestip, anmeldelser og købsressourcer — organiseret i én let søgbar hub.',
    ctaPrimary: 'Udforsk AllChinaBuy Regneark',
    ctaSecondary: 'Gennemse Produktkategorier',
    trustLine: 'Uafhængig Ressource • Opdaterede Guider • Flersproget • Forskningsfokuseret',
  },
  search: {
    h2: 'Find en AllChinaBuy Regneark Ressource',
    placeholder: 'Søg efter produkter, sælgere, regneark, QC, forsendelse eller guider...',
    button: 'Søg Ressourcer',
    popular: 'Populært:',
    tags: 'Regneark • Sko • Tøj • QC • Forsendelse • Anmeldelse • Kupon',
  },
  categories: {
    h2: 'Populære AllChinaBuy Regneark Kategorier',
    subtitle: 'Udforsk produktkategorier og find, hvad du har brug for via AllChinaBuy regnearket.',
    shoes: 'Sko',
    hoodies: 'Hoodies/Sweatre',
    tshirts: 'T-Shirts',
    jackets: 'Jakker',
    pants: 'Bukser/Shorts',
    headwear: 'Hovedbeklædning',
    sets: 'Sæt',
    underwear: 'Undertøj/Underbukser',
    jersey: 'Trøjer',
    accessories: 'Tilbehør',
    bags: 'Tasker',
    belts: 'Bælter',
    perfumes: 'Parfumer',
    other: 'Andet',
    viewAll: 'Se Alle Kategorier',
  },
  value: {
    h2: 'Alt Du Har Brug for at Undersøge AllChinaBuy på Ét Sted',
    description: 'Søgning gennem spredte produktlinks, sælgerlister og købsguider kan være tidskrævende. Vores mål er at organisere nyttig AllChinaBuy-information i klare kategorier, så du kan undersøge produkter, forstå QC, sammenligne forsendelsesmuligheder og træffe mere informerede købsbeslutninger.',
    cards: {
      spreadsheet: { title: 'Regneark-Ressourcer', desc: 'Udforsk organiserede regneark-ressourcer og produktopdagelsesguider.' },
      seller: { title: 'Sælgerundersøgelse', desc: 'Lær at evaluere sælgerinformation og produktlister.' },
      qc: { title: 'QC-Guider', desc: 'Forstå QC-fotos, kvalitetsfaktorer og almindelige problemer.' },
      shipping: { title: 'Forsendelsesguider', desc: 'Lær om forsendelsesmetoder, omkostninger og leveringsfaktorer.' },
      reviews: { title: 'Anmeldelser & Sammenligninger', desc: 'Sammenlign vigtige faktorer, før du træffer en beslutning.' },
      safety: { title: 'Sikkerhedscenter', desc: 'Forstå købs-, betalings-, sælger- og forsendelsesrisici.' },
    },
  },
  review: {
    h2: 'AllChinaBuy Anmeldelse',
    description: 'Leder du efter en uafhængig oversigt? Udforsk vores AllChinaBuy-anmeldelse, der dækker køb, forsendelse, lagerprocesser, sælgerundersøgelse og almindelige risici.',
    cta: 'Læs AllChinaBuy-Anmeldelsen',
  },
  shipping: {
    h2: 'AllChinaBuy Forsendelsesomkostning & Forsendelsesguide',
    description: 'Forsendelse kan variere efter destination, pakkestørrelse, vægt, forsendelsesmetode og speditørbetingelser. Lær, hvilke faktorer der kan påvirke AllChinaBuy-forsendelsesomkostninger og leveringstider.',
    cta: 'Se Forsendelsesguide',
  },
  coupon: {
    h2: 'AllChinaBuy Kupon & Rabatkode',
    description: 'Leder du efter aktuelle AllChinaBuy-kuponer eller rabatkoder? Tjek vores seneste ressourceside og skelne klart mellem verificerede, uverificerede og udløbne tilbud.',
    cta: 'Tjek Aktuelle Tilbud',
  },
  warehouse: {
    h2: 'AllChinaBuy Lager-Guide',
    description: 'Lær, hvordan lageropbevaring, QC, pakkekonsolidering og forsendelsesforberedelse kan påvirke købsprocessen.',
    cta: 'Udforsk Lager-Guide',
  },
  legit: {
    h2: 'Er AllChinaBuy Legitimt?',
    description: 'Inden du bruger en shopping- eller købsagent-platform, skal du forstå sælgerrisiko, betalingsovervejelser, produktkvalitet, forsendelse og tvistprocedurer.',
    cta: 'Læs Sikkerheds- & Legitimitets-Guide',
  },
  finalCta: {
    h2: 'Klar til at Udforske AllChinaBuy Regnearket?',
    description: 'Start med regnearket, udforsk produktkategorier, læs de seneste guider, og lær, hvordan du undersøger produkter, sælgere, QC og forsendelse mere effektivt.',
    ctaPrimary: 'Udforsk AllChinaBuy Regneark',
    ctaSecondary: 'Læs Købsguider',
  },
  mainSite: {
    title: 'AllChinaBuy Regneark',
    button: 'Køb Det Nu',
    description: 'Udforsk det fulde AllChinaBuy regneark på vores hovedwebsite for det komplette produktkatalog.',
  },
  footer: {
    tagline: 'Uafhængig AllChinaBuy Regneark Ressource-Hub',
    resources: 'Ressourcer',
    spreadsheet: 'Regneark',
    categories: 'Kategorier',
    review: 'Anmeldelse',
    shipping: 'Forsendelse',
    coupon: 'Kupon',
    warehouse: 'Lager',
    legit: 'Er det Legitimt?',
    guides: 'Guider',
    company: 'Virksomhed',
    about: 'Om os',
    contact: 'Kontakt',
    privacy: 'Privatlivspolitik',
    terms: 'Servicevilkår',
    disclaimer: 'Ansvarsfraskrivelse',
    editorial: 'Redaktionel Politik',
    rights: 'Alle rettigheder forbeholdes.',
    disclaimerText: 'Dette website tilbyder generelle uddannelsesmæssige oplysninger. Det garanterer ikke sælgerkvalitet, produktægthed, forsendelsesresultater, refusioner eller transaktionsresultater.',
  },
  languages: {
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
    da: 'Dansk',
  },
  common: {
    readMore: 'Læs Mere',
    learnMore: 'Lær Mere',
    explore: 'Udforsk',
    backToHome: 'Tilbage til Hjem',
    notFound: 'Side Ikke Fundet',
    notFoundDesc: 'Den side, du leder efter, findes ikke.',
  },
  meta: {
    siteName: 'AllChinaBuy Regneark Hub',
    homeTitle: 'AllChinaBuy Regneark 2026 — Produkter, Sælgere & Købsguider',
    homeDesc: 'Udforsk AllChinaBuy Regnearket for produkter, sælgerressourcer, QC-guider, forsendelsesinformation, anmeldelser, kuponer og praktiske købstip.',
  },
};